import { useState } from 'react';
import { useSelector } from 'react-redux';
import { getRouteIdBySegmentIds } from './helpers';

export const useAvailableOptions = () => {
  const availableOptions = useSelector((state) => {
    const result = [];
    const { service_routes: serviceRoutes, segments } = state.sealink;

    serviceRoutes.forEach((route) => {
      [route.forward_journey, route.return_journey].forEach((journey, idx) => {
        const isForward = idx === 0;
        const seg = segments[journey.segments[0]] || {};

        // Extract the stop IDs from the segment's subroutes
        const firstSubroute = seg.subroutes?.[0];
        const lastSubroute = seg.subroutes?.[seg.subroutes?.length - 1];

        // Get both from and to stop IDs for proper filtering
        const from_stop_id = firstSubroute?.from_route_stop_qt_id ?? null;
        const to_stop_id = lastSubroute?.to_route_stop_qt_id ?? null;

        result.push({
          name: journey.name,
          routeId: getRouteIdBySegmentIds(journey.segments, segments),
          from_stop_id,
          to_stop_id,
          isForward,
        });
      });
    });
    return result;
  });

  const [selectedOption, setSelectedOption] = useState(
    availableOptions[0].routeId
  );
  return [availableOptions, selectedOption, setSelectedOption];
};
